define("appkit/adapters/application", 
  ["exports"],
  function(__exports__) {
    "use strict";
    // store stuff for all adapters in here
    __exports__["default"] = DS.Adapter.extend({

    });
  });